import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Paper from 'components/Paper';

import classes from './OrgSelection.less';
import ActionButton from 'components/ActionButton';

const SelectOrgItem = ({ org, onChange, selected }) => (
  <Paper
    className={selected ? classes.organizationSelectionOptSelected : classes.organizationSelectionOpt}
    onClick={() => onChange(org)}
  >
    <p>{org}</p>
  </Paper>
);

SelectOrgItem.propTypes = {
  org: PropTypes.string,
  onChange: PropTypes.func,
  selected: PropTypes.string
};

const OrgSelection = ({ availableOrgs, allOrgs, selectedOrg, setSelectedOrg, onSelectOrg }) => (
  <div style={{ textAlign: 'center' }}>
    <div className={classes.organizationSelectionHeader}>
      <FormattedMessage id="dictionary.chooseOrganization" />
    </div>
    <div className={classes.organizationSelection}>
      {availableOrgs.map(o => {
        const orgName = allOrgs.find(org => org.orgId === o)?.displayName;
        return (
          <div key={o} style={{ width: '100%' }}>
            <SelectOrgItem org={orgName} onChange={() => setSelectedOrg(o)} selected={selectedOrg === o} />
          </div>
        );
      })}

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <ActionButton
          localeId="dictionary.chooseOrganizationButton"
          onClick={() => onSelectOrg(selectedOrg)}
          border
          secondary
        />
      </div>
    </div>
  </div>
);

OrgSelection.propTypes = {
  availableOrgs: PropTypes.string,
  allOrgs: PropTypes.string,
  selectedOrg: PropTypes.string,
  setSelectedOrg: PropTypes.func,
  onSelectOrg: PropTypes.func
};

export default OrgSelection;
